import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MaintenanceActions {
  static SET_MAINTENANCE_STATE = 'SET_MAINTENANCE_STATE';
  static MAINTENANCE_CHECK_FAILED = 'MAINTENANCE_CHECK_FAILED';

  setMaintenanceState(payload) {
    return {
      type: MaintenanceActions.SET_MAINTENANCE_STATE,
      payload,
    };
  }

  maintenanceCheckFailed(payload) {
    return {
      type: MaintenanceActions.MAINTENANCE_CHECK_FAILED,
      payload,
    };
  }
}
